import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-block"
}
const _hoisted_2 = ["data-dusk"]

import { computed, PropType } from 'vue';
import { HIGHLIGHT_BG_COLORS } from '@/constants/webshop';

type NumberBadgeColor = 'primary' | 'white' | 'danger';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberBadge',
  props: {
  badgeNumber: { type: [String, Number], required: true },
  isEnabled: { type: Boolean, default: true },
  color: {
    type: String as PropType<NumberBadgeColor | typeof HIGHLIGHT_BG_COLORS[number]>,
    default: 'primary'
  },
  text: { type: String, default: '' },
  showNumber: { type: Boolean, default: true },
  dataDusk: { type: String, default: null }
},
  setup(__props) {

const props = __props;

const hasText = computed(() => props.text.trim().length > 0);

const isTextMode = computed(() => !props.showNumber && hasText.value);

const isHighlightBgColor = (
  value: unknown
): value is typeof HIGHLIGHT_BG_COLORS[number] =>
  typeof value === 'string' &&
  (HIGHLIGHT_BG_COLORS as readonly string[]).includes(value);

const safeNumberColor = computed<NumberBadgeColor>(() => {
  if (props.color === 'primary' || props.color === 'white' || props.color === 'danger') {
    return props.color;
  }
  return 'primary';
});

const safeHighlightBgColor = computed<typeof HIGHLIGHT_BG_COLORS[number] | null>(() => {
  if (!isTextMode.value) {
    return null;
  }
  return isHighlightBgColor(props.color) ? props.color : null;
});

const shouldShowNumberBadge = computed(() => props.showNumber);
const shouldShowTextBadge = computed(() => isTextMode.value && !!safeHighlightBgColor.value);

const numberBadgeBgClass = computed(() => {
  if (!props.isEnabled) {
    return 'bg-gray-100';
  }

  switch (safeNumberColor.value) {
  case 'primary':
    return 'bg-primary-500';
  case 'white':
    return 'bg-white';
  case 'danger':
    return 'bg-danger-500';
  default:
    return 'bg-primary-500';
  }
});

const numberBadgeTextClass = computed(() => {
  if (!props.isEnabled) {
    return 'text-gray-600';
  }

  if (safeNumberColor.value === 'white') {
    return 'text-primary-500';
  }

  return 'text-white';
});

const textBadgeBgClass = computed<string | null>(() => {
  const c = safeHighlightBgColor.value;
  return c ? `bg-${c}` : null;
});

return (_ctx: any,_cache: any) => {
  return (shouldShowNumberBadge.value || shouldShowTextBadge.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (shouldShowNumberBadge.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass(["h-4 px-1 rounded flex justify-center", numberBadgeBgClass.value]),
                "data-dusk": "badge-container"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["text-2xs font-semibold self-center", numberBadgeTextClass.value]),
                  "data-dusk": "badge-number"
                }, _toDisplayString(__props.badgeNumber), 3)
              ], 2)
            ]))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["inline-flex items-center px-2 h-5 rounded text-sm leading-none font-medium", [textBadgeBgClass.value, 'text-white']]),
              "data-dusk": __props.dataDusk
            }, _toDisplayString(__props.text), 11, _hoisted_2))
      ], 64))
    : _createCommentVNode("", true)
}
}

})